const layout = {
  header: {
    changeView: {
      toasts: {
        success: 'El sitio cambió correctamente',
        failure: 'Ocurrió un error inesperado',
      },
    },
  },

  sideBar: {
    menu: {
      home: {
        title: 'Domicilio',
      },
      parents: {
        title: 'Padres',
      },
      trips: {
        title: 'Viajes',
        children: {
          trips: 'Viajes',
          timeline: 'Línea de tiempo',
          feedbacks: 'Comentarios',
        },
      },
      jobs: {
        title: 'Reservas',
        children: {
          jobs: 'Reservas',
          calendar: 'Calendario',
          passengers: 'Pasajeros',
          students: 'Alumnos',
          employees: 'Empleados',
          profiles: 'Perfiles',
          parents: 'Padres',
          caregivers: 'Cuidadores',
        },
      },
      drivers: {
        title: 'Conductores',
        children: {
          drivers: 'Conductores',
          onlineDrivers: 'Conductores en línea',
          driverShifts: 'Turnos del conductor',
          driverShiftsTemplates: 'Plantillas de turnos',
          livemap: 'Mapa en Vivo',
        },
      },
      vehicles: {
        title: 'Vehículos',
      },
      integrations: {
        title: 'Integraciones',
      },
      automations: {
        title: 'Automatizaciones',
      },
      reports: {
        title: 'Informes',
      },
      more: {
        title: 'Más',
        children: {
          areas: 'Zonas',
          attributes: 'Atributos',
          blacklist: 'Blacklist',
          extraServices: 'Servicios extra',
          fares: 'Tarifas',
          holidays: 'Vacaciones',
          locations: 'Ubicaciones',
          permissions: 'Roles y permisos',
          profiles: 'Perfiles',
          rates: 'Tasas',
          services: 'Servicios',
          shifts: 'Turnos',
          shuttles: 'Shuttles',
          sites: 'Sitios',
          suppliers: 'Proveedores',
          settings: 'Configuraciones del sistema',
          uploadData: 'Cargar datos',
          users: 'Usuarios',
          apiKeys: 'Claves API',
          customRules: 'Reglas personalizadas',
          facilities: 'Instalaciones',
          roiSimulation: 'Simulación de ROI',
        },
      },
    },
    settings: {
      myProfile: {
        button: 'Mi perfil',
      },
      languages: {
        button: 'Idioma',
      },
      themes: {
        button: 'Cambiar tema',
        options: {
          light: 'Light',
          dark: 'Dark',
        },
      },
      logout: 'Cerrar sesión',
    },
  },

  footer: {
    poweredBy: 'Desarrollado por',
    moovex: 'Moovex',
  },

  asideQueue: {
    headerQueue: 'Cola',
    empty: 'No se encontraron reservas en cola',
    btnRemove: 'Eliminar de la cola',
    btnAssign: 'Mover para expedición',
  },
};

export default layout;
